module.exports = __webpack_public_path__ + "img/left.bb199bd5.svg";